import { useQuery } from "@tanstack/react-query";
import { fetchTransactionByAccessId } from "@/services/api";
import { toast } from "sonner";

export const useTransactionDetail = (accessId: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["accessId", accessId],
    queryFn: () => fetchTransactionByAccessId(accessId!),
    enabled: !!accessId,
    retry: 1,
    refetchOnWindowFocus: false,
    meta: {
      onError: (err: Error) => {
        toast.error("Failed to load transaction details", {
          description: "Please check the transaction ID and try again later.",
        });
        console.error("Error fetching transaction:", err);
      },
    },
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
